import { Injectable } from '@angular/core';

@Injectable()
export class ConfirmModalService {
    pop: (message?: string[], title?: string, showConfimButton?: boolean, confirmButtonText?: string, showCancelButton?: boolean, abortButtonText?: string, type?: string) => Promise<boolean>;
}